import React, {useEffect, useRef} from 'react';

function ImageReview({ file, selectFile, onImageUploaded, backButton }) {
    const fileInputRef = useRef(null);

    const uploadImage = () => {
        fileInputRef.current.click();
    };

    return (
        <>
            <section className="container">
                <div className="row py-3">
                    <div className="mx-auto text-center">
                        <button type="button"
                            className="verification-button-back"
                            onClick={backButton}
                        >
                            <img src={require("../assets/img/chevron-left.svg").default}/>
                        </button>
                        <h1 className="py-2">Check your image</h1>
                        <div className="fs-4">
                            <img className="py-3 px-5"
                                style={{width: "100%"}}
                                src={URL.createObjectURL(file)}
                            />
                            <h6 className="py-3 px-5">Make sure your details are clear and unobstructed</h6>
                        </div>
                    </div>
                </div>
            </section>
            <div className="py-3 d-flex justify-content-center">
                <div className="span2 d-flex justify-content-between py-2 verification-review-container">
                    <button
                        className="btn btn-block verification-button-redo"
                        onClick={uploadImage}
                    >
                        <span className="text-uppercase pb-1 fs-5">Redo</span>
                    </button>
                    <button
                        className="btn btn-block verification-button-upload"
                        onClick={() => {
                            onImageUploaded()
                        }}
                    >
                        <span className="text-uppercase pb-1 fs-5">Upload</span>
                    </button>
                    <input
                        type="file"
                        id="files"
                        ref={fileInputRef}
                        accept=".jpg,.png,.jpeg,.bmp,.gif,image/jpg,image/gif,image/png,image/bmp"
                        multiple=""
                        style={{ display: "none" }}
                        onChange={() => selectFile(fileInputRef.current.files[0])}
                    />
                </div>
            </div>
        </>
    );
}

export default ImageReview;